module.exports = __webpack_public_path__ + "img/013.791eea9f.jpg";